import { computed, observable } from "mobx";
import { IUserJSON } from "../interfaces";
import { ROLES } from "../constants";

export class User {
  id!: number;

  @observable
  merchantId = "";

  @observable
  email = "";

  @observable
  phone = "";

  @observable
  roles = new Array<string>();

  @observable
  fullName = "";

  @observable
  brand: string | null = null;

  tags: any;

  json!: IUserJSON;

  country = "";

  @computed
  get isAdmin(): boolean {
    return (
      this.roles?.includes(ROLES.ADMIN) || this.roles?.includes(ROLES.OWNER)
    );
  }

  @computed
  get isOwner(): boolean {
    return this.roles?.includes(ROLES.OWNER);
  }

  @computed
  get isManager(): boolean {
    return this.roles.includes(ROLES.MANAGER);
  }

  @computed
  get isCashier(): boolean {
    return this.roles.includes(ROLES.CASHIER);
  }

  @computed
  get isTemp(): boolean {
    return this.roles.includes(ROLES.TEMP);
  }

  @computed
  get hasTags(): boolean {
    return this.tagsHumanized.length !== 0;
  }

  tagsToArrayOfStrings(tags: any, stringTags: string[] = []): string[] {
    if (!tags) {
      return [];
    }

    const reduced = Object.keys(tags).reduce(
      (all: string[], current: string) => {
        if (["and", "or"].includes(current)) {
          const _mapped: any[] = tags[current].map((_current: any) =>
            this.tagsToArrayOfStrings(_current, all)
          );
          return [...all, ..._mapped];
        }

        return [...all, tags[current]];
      },
      [] as string[]
    );

    return [...stringTags, ...reduced].flat();
  }

  get tagsHumanized(): string[] {
    return this.tagsToArrayOfStrings(this.tags);
  }

  static fromJSON = (json: IUserJSON): User => {
    const user = new User();
    user.id = json.id;
    user.json = json;
    user.email = json.email;
    user.phone = json.phone;
    user.merchantId = json.merchant_id;
    user.roles = json.roles;
    user.fullName = json.full_name;
    user.brand = json.brand;
    user.tags = json.tags;
    user.country = json.country || "";

    return user;
  };
}
